export const getElementId = (id?: string | null) => id?.split('#').at(-1) ?? '';
